'use strict';
import $ from 'jquery';
import 'slick-carousel';

export default class HomeHero {
    static init() {
        $('.ontinue-home-hero').each((index, el) => {
            new HomeHero($(el));
        });
    }

    constructor($el) {
        this.el = $el;
        const activeClass = 'slick-active';
        this.el.find('.ontinue-home-hero-carousel')
            .on('init', function () {
                $('.slick-dots li:first-of-type').addClass(activeClass);
            })
            .on('afterChange', function (event, slick, currentSlide) {
                const $dots = $el.find('.slick-dots');
                $('li', $dots).removeClass(activeClass);
                $dots.each(function () {
                    $('li', $(this)).eq(currentSlide).addClass(activeClass);
                });
            }).slick({
                rows: 0,
                mobileFirst: true,
                arrows: false,
                dots: true,
                appendDots: $el.find('.slick-nav'),
                autoplay: true,
                autoplaySpeed: 5000,
                fade: true,
            });

    }
}